import { createFileRoute, redirect } from '@tanstack/react-router';

import { TokenManager } from '../auth/TokenManager';
import { queries } from '../common/api/queryKeys/queries';
import { Role } from '../user/model/role.model';
import { SessionService } from '../user/session/SessionService';

export const Route = createFileRoute('/_app/user/detail/$id')({
    beforeLoad: async ({ params, context }) => {
        const token = await TokenManager.getInstance().getToken();
        const role = await context.queryClient.ensureQueryData<Role>({
            queryKey: queries.role.information.queryKey,
            queryFn: () => SessionService.getInstance().loadRoleInformation(token),
        });

        if (role.isSuperAdmin()) {
            throw redirect({
                to: '/members/$id',
                params: { id: params.id },
            });
        }

        if (role.isCustomer()) {
            throw redirect({
                to: '/customer-groups/$groupId/members/$userId',
                params: { groupId: role.group.id, userId: params.id },
            });
        }

        if (role.isSupplier()) {
            throw redirect({
                to: '/supplier-groups/$groupId/members/$userId',
                params: { groupId: role.group.id, userId: params.id },
            });
        }

        throw redirect({ to: '/settings' });
    },
});
